/**
 * Add new team member.
 */
export function addNewTeamMember() {
  const addTeamMemberModal = $( '#add-new-team-member' );
  if ( !addTeamMemberModal.length ) {
    return;
  }

  window.mce = 'mce' in window ? window.mce : {};

  const addNewTeamMemberButton = addTeamMemberModal.find( '.send-invite-to-member' );
  const validationError = addTeamMemberModal.find( '.modal-error' );
  const validationSuccess = addTeamMemberModal.find( '.modal-success' );

  var formData = {};
  $( addNewTeamMemberButton ).on( 'click', function addTeamMember( event ) {
    event.preventDefault();

    formData.action = 'add-member-to-team';
    formData.data = {
      member_name:addTeamMemberModal.find( '#member_name' ).val(),
      member_email:addTeamMemberModal.find( '#member_email' ).val(),
      team_id:addTeamMemberModal.find( '#team_id' ).val()
    };

    $.ajax({
      url:`${window.mce.api_url}teams`,
      type:'post',
      data:formData,
      success:function( data ) {
        if ( typeof data.success !== 'undefined' && data.success === true ) {
          validationSuccess.find( 'span' ).text( data.message );
          setTimeout( function timeoutForReload() {
            window.location.reload();
          }, 3000 );
        } else if ( typeof data.error !== 'undefined' ) {
          validationError.find( 'span' ).text( data.error );
          setTimeout( function removeError() {
            validationError.find( 'span' ).text( '' );
          }, 3000 );
        }
      }
    });
  });
}
